import { Helmet } from 'react-helmet';

const HelmetBasedOnDomain = () => {
  const domainName = window.location.hostname;
  let favicon;
  let brandName;

  if (
    domainName === 'fastpcp.com' ||
    domainName === 'dev.fastpcp.com' ||
    domainName === 'pre.fastpcp.com'
  ) {
    favicon = '/favicon_fastPcP.ico';
    brandName = 'Fast PCP';
  } else if (
    domainName === 'fastpcpredress.co.uk' ||
    domainName === 'dev.fastpcpredress.co.uk' ||
    domainName === 'pre.fastpcpredress.co.uk'
  ) {
    favicon = '/favicon_fastPcP.ico';
    brandName = 'Fast PCP Redress';
  } else {
    favicon = '/favicon_fastPcP.ico';
    brandName = 'Fast PCP';
  }

  return (
    <Helmet>
      <link rel="icon" href={favicon} />
      <title>{brandName}</title>
    </Helmet>
  );
};
export default HelmetBasedOnDomain;
